module.exports = __webpack_public_path__ + "img/IMG_1933.beb2f6a8.jpg";